import { Layout } from 'pages/auth/layout';
import { useEffect } from 'react';
import { HOME_ROUTES, TOKENS } from 'pages/auth/constants';
import { useLocalStorage } from 'hooks';
import { isOnPrem } from 'config';
import LoginForm from './LoginForm';
import LoginWithSSOForm from './LoginWithSSOForm';
import { useNavigate } from 'react-router-dom';

export const EULA_LINK = 'https://www.cynet.com/eula-console';

const Login = () => {
  const [token] = useLocalStorage(TOKENS.ACCESS_TOKEN_EXPIRATION, null);
  const [isSiteContainerRoute] = useLocalStorage(TOKENS.IS_SITE_CONTAINER_ROUTE, null);
  const isSSOFlow = !isOnPrem;
  const navigate = useNavigate();

  useEffect(() => {
    if (token && isSiteContainerRoute !== null) {
      const navigateTo = isSiteContainerRoute ? HOME_ROUTES.global : HOME_ROUTES.local;
      navigate(navigateTo);
    }
  }, []);

  return <Layout>{isSSOFlow ? <LoginWithSSOForm /> : <LoginForm />}</Layout>;
};

export default Login;
